import { FORMAT_HTTP_HEADERS, globalTracer, initGlobalTracer, Span } from 'opentracing'

import { BeaconEventSender } from './beacon-event-sender'
import { CustomTracer } from './custom-tracer'

let _rootSpan: Span | undefined

export function initTracing(tracingUrl: string): void {
  const tracer = new CustomTracer(new BeaconEventSender(tracingUrl))
  initGlobalTracer(tracer)

  const span = tracer.startSpan('root-span')
  span.setTag('www.user_agent', navigator.userAgent)
  global.setTimeout(() => span.finish(), 1000)
  _rootSpan = span
}

export function injectSpanInto(headers: any, name: string): Span {
  const tracer = globalTracer()
  const span = tracer.startSpan(name, { childOf: _rootSpan })
  tracer.inject(span, FORMAT_HTTP_HEADERS, headers)

  return span
}
